<template>
  <section class="section1">
    <div class="header-logo">
      <a
        href="https://marginx.io"
        target="_blank"
        rel="noopener noreferrer"
        class="flex-align-center"
        ><i class="icon icon-inviteActivity-marginx-logo"></i
        ><i class="icon icon-inviteActivity-logo-font"></i
      ></a>
    </div>
    <div class="bg">
      <div class="bg-img">
        <img src="@/assets/images/inviteActivity/m-header.svg" alt="" />
      </div>
    </div>
    <div class="container">
      <div class="section1-text">
        <h3>Join MarginX and get airdrop your</h3>
        <h3 class="text-MarginX">very own starter NFT!</h3>
        <h4>
          This entitles you to 5% trading rebates and 5% referral commissions...
          for a lifetime!
        </h4>
      </div>
      <div class="section1-text-p">
        <strong>
          This process is not currently supported on mobile. Please open this
          referral link in your desktop browser for a smoother experience.
        </strong>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "Section1",
};
</script>
<style lang="scss" scoped>
.section1 {
  position: relative;
  overflow: hidden;

  .header-logo {
    position: absolute;
    padding: 10px;
    box-sizing: border-box;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 3;

    .icon-inviteActivity-logo-font {
      margin-left: 10px;
    }
  }

  .container {
    position: relative;
    padding-bottom: 80px;
  }

  .bg {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    z-index: 0;
    .bg-img {
      position: absolute;
      right: 0px;
      bottom: 0px;
      left: 0;
      top: 0;
      z-index: -1;
    }
  }

  .section1-text-p {
    margin-top: 22px;
    background: rgb(235, 84, 148);
    padding: 16px 32px;
    strong {
      text-align: center;
      font-size: 14px;
      line-height: 20px;
      display: block;
    }
  }

  .section1-text {
    position: relative;
    z-index: 1;
    margin: 0 auto;
    text-align: center;
    padding-top: 94px;
    padding: 94px 16px 0;

    .text-MarginX {
      color: #a6f616;
    }

    h4 {
      font-size: 16px;
      line-height: 24px;
      opacity: 0.6;
      margin-top: 22px;
    }
  }

  .section1-img {
    position: relative;
  }

  .section1-block {
    position: relative;
    z-index: 5;
    display: flex;
    padding: 0 15px;
    justify-content: space-between;
  }

  .section1-box {
    position: relative;
    width: 464px;
    height: 96px;
    background-color: #28bad0;
    box-shadow: 5px 6px 81px 0px rgba(0, 0, 0, 0.08);
    border-radius: 17px;
    padding: 15px;
    box-sizing: border-box;
    color: #ffffff;
    margin: 0 auto;

    .icon-box {
      width: 98px;
      text-align: center;
      width: 20px;
      display: inline-flex;
    }

    height: 34px;
    padding: 4px 9px;
    flex: 1;

    &:first-child {
      // margin-right: 10px;
      max-width: 200px;
      margin-bottom: 15px;
    }

    .icon-c-4270,
    .icon-c-4273 {
      width: 20px;
      height: 20px;
    }

    &.content-2 {
      margin-bottom: 6px;
    }

    h6 {
      opacity: 1;
      font-size: 14px;
      line-height: 11px;
      margin-left: 20px;
    }
  }
}
</style>
